// extracted by mini-css-extract-plugin
module.exports = {"modalDescription":"ybbQnP6EZ21ZEuI24YM42w==","modalButtons":"aTKK4Ei6mdhjjD1BHq7zEA=="};